module.exports = __webpack_public_path__ + "img/nsBig.6f78a368.jpg";